import Model from '@/Models/Model';
import { Inertia } from '@inertiajs/inertia';

export default class Contact extends Model {
    delete() {
        Inertia.delete(`/backoffice/messages/${this.id}`);
    }
    process() {
        Inertia.put(`/backoffice/messages/${this.id}`);
    }
}
